var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Base from "../Base.js";
import InstancePlugin from "./InstancePlugin.js";
var Pluggable_default = (Target) => {
  var _a;
  return _a = class extends (Target || Base) {
    /**
     * Specify plugins (an array of classes) in config
     * @config {Function[]} plugins
     * @category Misc
     * @advanced
     */
    /**
     * Map of applied plugins
     * @property {Object<String,Core.mixin.InstancePlugin>}
     * @readonly
     * @category Misc
     * @advanced
     */
    get plugins() {
      if (!this._plugins) {
        this._plugins = {};
      }
      return this._plugins;
    }
    set plugins(plugins) {
      if (plugins) {
        if (!Array.isArray(plugins))
          plugins = [plugins];
        InstancePlugin.initPlugins(this, ...plugins);
      }
      this.initPlugins();
    }
    /**
     * Template method which may be implemented in subclasses to initialize any plugins.
     * This method is empty in the `Pluggable` base class.
     * @internal
     */
    initPlugins() {
    }
    /**
     * Adds plugins to an instance.
     * @param {Function[]} plugins The plugins to add
     * @category Misc
     * @advanced
     */
    addPlugins(...plugins) {
      InstancePlugin.initPlugins(this, ...plugins);
    }
    /**
     * Adds a plugin to an instance, with a configuration object passed to the plugin constructor
     * @param plugin
     * @param config
     * @returns {Core.mixin.InstancePlugin}
     * @internal
     */
    addPlugin(plugin, config) {
      return InstancePlugin.initPlugin(this, plugin, config);
    }
    /**
     * Checks if instance has plugin.
     * @param {String|Function} pluginClassOrName Plugin or name to check for
     * @returns {Boolean}
     * @category Misc
     * @advanced
     */
    hasPlugin(pluginClassOrName) {
      return this.getPlugin(pluginClassOrName) != null;
    }
    /**
     * Get a plugin instance.
     * @param {String|Function} pluginClassOrName
     * @returns {Core.mixin.InstancePlugin}
     * @category Misc
     * @advanced
     */
    getPlugin(pluginClassOrName) {
      var _a2;
      if (typeof pluginClassOrName === "function") {
        pluginClassOrName = pluginClassOrName.$$name;
      }
      return (_a2 = this.plugins) == null ? void 0 : _a2[pluginClassOrName];
    }
    // This does not need a className on Widgets.
    // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
    // to the Widget it's mixed in to should implement this.
    get widgetClass() {
    }
  }, __publicField(_a, "$name", "Pluggable"), _a;
};
export {
  Pluggable_default as default
};
